import { cliente } from '@/lib/cliente';
import type { AmbitoPesos, GuardarPesos } from '@adelante/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

/** Matriz de pesos (todos los grupos) del ámbito: 'sprint' | 'partida'. */
export function useMatrizPesos(ambito: AmbitoPesos) {
  return useQuery({
    queryKey: ['pesos', ambito],
    queryFn: () => cliente.pesos.matriz(ambito),
  });
}

/** Guarda la matriz de pesos de un ámbito. */
export function useGuardarPesos() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ ambito, body }: { ambito: AmbitoPesos; body: GuardarPesos }) =>
      cliente.pesos.guardar(ambito, body),
    onSuccess: (_d, vars) => {
      qc.invalidateQueries({ queryKey: ['pesos', vars.ambito] });
    },
  });
}
